export enum CurrencyEnum {
  EUR = 'EUR',
  USD = 'USD',
  SEK = 'SEK',
}
